import { Options } from '@sheerid/jslib';
import { messagesEN } from './lib/intl/en-US';
import { messagesPT } from './lib/intl/pt-BR';
import { RecursivePartial } from './lib/types/types';


export const programId = '62a76ece385c760af22e0ee9';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
        'pt-BR': messagesPT,
    },
    privacyPolicyUrl: 'https://www.linkedin.com/legal/privacy-policy',
};
